'use client';

import { Progress } from '@/components/ui/progress';
import { useProgressing } from '@/hooks/use-progressing';
import { cn } from '@/lib/utils';
import { CustomLoadingProps } from './types';

export function ProgressLoading({ loading, className }: CustomLoadingProps) {
    const { progress } = useProgressing(loading ?? true);

    return (
        <Progress className={cn('h-0.5 w-full', className)} value={progress} />
    );
}
